import React from 'react';
import './App.css';
import Header from './components/Header/Header'; 
import Footer from './components/Footer/Footer';
import Home from './components/Home/Home';

function App() {
  return (
    <div className="App">
      <div className="row1">
        {/* Row 1 (Top) */}
        <Header />
      </div>

      <div className="row2">
       <Home />
      </div>

      <div className="row3">
        {/* Row 4 (Bottom) */}
        <Footer />
      </div>
    </div>
  );
}

export default App;
